import { useEffect, useState } from "react";
import styles from "./cartIcon.module.scss";
import { Icon } from "@monta/design-system";
import { fixString } from "@monta/router-js";
import type { TUtils } from "@monta/utils";

export interface CartIconProps {
  cart: TUtils["cart"];
}

const CartIcon = (props: CartIconProps) => {
  const { cart } = props;
  const cartItems = cart.useCartItems();
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    setCount(cartItems.length);
  }, [cartItems]);
  return (
    <>
      {count ? (
        <a href={fixString("/cart", "APPLICATION_URL")}>
          <span className={styles["cart"]} id={"goToCartFromMenu"}>
            <span className={styles["cart__count"]}>{count}</span>
            <Icon
              icon={"mi-Buy-Linear"}
              size={1.5}
              className={styles["cart__icon"]}
            />
          </span>
        </a>
      ) : (
        <> </>
      )}
    </>
  );
};

export default CartIcon;
